import { FaUserCircle } from "react-icons/fa";
import styles from "../../css/messages.module.css";
import { BASE_URL } from "../../../../constants/apiConstants";

export const ChatHeader = ({ activeGroup, getMemberName }) => {
  return (
    <div className={styles.chatHeader}>
      <div className={`d-flex align-items-center gap-3`}>
        {!activeGroup?.main_member?.image ? (
          <FaUserCircle color="#999" className={styles.profileImg} />
        ) : (
          <img
            src={`${BASE_URL}${activeGroup?.main_member?.image}`}
            alt=""
            className={styles.profileImg}
          />
        )}
        <span style={{ color: "#4F4F4F", fontWeight: "700" }}>
          {getMemberName(activeGroup?.main_member)}
        </span>
      </div>
    </div>

  );
};
